import "./PrivilegeHeader.css";

const PrivilegeHeader = () => {
  return (
    <header className="privilege-header">
      <div className="privilege-header-images">
        <img
          src="/Frame 29611912.svg"
          alt="Frame 29611912"
          className="privilege-header-top-image"
        />
        <img
          src="/Premium Club.svg"
          alt="Premium Club"
          className="privilege-header-bottom-image"
        />
      </div>
    </header>
  );
};

export default PrivilegeHeader;
